export default __webpack_public_path__ + "static/media/accordion_off.29ccca78.svg";